export class ViewExtraDefinition {
  public idml: string
  public description: string

  constructor(model: ViewExtraDefinition) {
    this.idml = model.idml
    this.description = model.description
  }
}
